import { render } from "./cpt-textarea-option.vue?vue&type=template&id=2f6a4ba5"
import script from "./cpt-textarea-option.vue?vue&type=script&lang=js"
export * from "./cpt-textarea-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__